import { LoadIcon, PlusIcon } from "@excalidraw/excalidraw/components/icons";
import { useI18n } from "@excalidraw/excalidraw/i18n";
import { WelcomeScreen } from "@excalidraw/excalidraw/index";
import React from "react";

export const AppWelcomeScreen: React.FC<{
  onCollabDialogOpen: () => any;
  onCreateBoard: () => void;
  onOpenFromSpryDrive: () => void;
  showStartChoices?: boolean;
  isCollabEnabled: boolean;
}> = React.memo((props) => {
  const { t } = useI18n();

  return (
    <WelcomeScreen>
      <WelcomeScreen.Hints.MenuHint>
        {t("welcomeScreen.app.menuHint")}
      </WelcomeScreen.Hints.MenuHint>
      <WelcomeScreen.Hints.ToolbarHint />
      <WelcomeScreen.Hints.HelpHint />
      <WelcomeScreen.Center>
        <div style={{ height: "4rem", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "3rem", fontWeight: "bold" }}>Spryboard</div>
        <WelcomeScreen.Center.Heading>
          "Collaborative whiteboarding made easy"
        </WelcomeScreen.Center.Heading>
        <WelcomeScreen.Center.Menu>
          {props.showStartChoices !== false && (
            <>
              <WelcomeScreen.Center.MenuItem
                onSelect={props.onCreateBoard}
                icon={PlusIcon}
                shortcut={null}
              >
                Create New Board
              </WelcomeScreen.Center.MenuItem>
              <WelcomeScreen.Center.MenuItem
                onSelect={props.onOpenFromSpryDrive}
                icon={LoadIcon}
                shortcut={null}
              >
                Open from SpryDrive
              </WelcomeScreen.Center.MenuItem>
            </>
          )}
          <WelcomeScreen.Center.MenuItemLoadScene />
          <WelcomeScreen.Center.MenuItemHelp />
          {props.isCollabEnabled && (
            <WelcomeScreen.Center.MenuItemLiveCollaborationTrigger
              onSelect={() => props.onCollabDialogOpen()}
            />
          )}
        </WelcomeScreen.Center.Menu>
      </WelcomeScreen.Center>
    </WelcomeScreen>
  );
});
